import * as actionTypes from "../actions/actionTypes";

const initialState = {
  auth: false,
  userId: null,
  phone: null,
  userSetup: false,
  adminSetUp: false,
  redirect_url: null,
  cart: [],
  name: "",
  checkout: false,
  shops: [],
  location: localStorage.location,
  homeLoad: false,
  delivery_address: null,
  merchant: {},
  shop: {},
  adminHome: {},
};

const userAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_USER:
      console.log("Uk action", action);
      return {
        ...state,
        name: action.user.user_name,
        auth: true,
        userId: action.user._id,
        userSetUp: true,
        phone: action.user.phone,
        delivery_address: action.user.delivery_address,
      };
    case actionTypes.SET_REDIRECT_URI:
      return {
        ...state,
        redirect_url: "/checkout",
      };
    case actionTypes.SET_CART:
      return {
        ...state,
        cart: action.cart,
      };
    case actionTypes.SET_CHECKOUT:
      return {
        ...state,
        checkout: true,
      };
    case actionTypes.SET_SHOPS:
      return {
        ...state,
        shops: action.shops,
        homeLoad: true,
      };
    case actionTypes.SET_SHOPS_CHANGE:
      return {
        ...state,
        shops: action.data.shops,
        location: action.data.location,
        homeLoad: true,
      };
    case actionTypes.HOME_LOAD_CHANGE:
      return {
        ...state,
        homeLoad: false,
      };
    case actionTypes.USER_LOGOUT:
      return {
        ...state,
        auth: false,
      };
    case actionTypes.SET_MERCHANT:
      return {
        ...state,
        merchant: action.data,
      };
    case actionTypes.SET_VIEWED_SHOP:
      return {
        ...state,
        shop: action.shop,
      };
    case actionTypes.SET_ADMIN_HOME:
      return {
        ...state,
        adminHome: action.adminData,
      };

    default:
      return state;
  }
};

export default userAuthReducer;
